// App-wide i18n — the language is a COMPANY setting (Andre 2026-08-24): the server
// resolves organisation.company.language_id and returns that language's bundle, so
// every user of a company sees the same words. Words are ADMIN master data
// (reference.translation, edited in admin Languages → Words, synced from the deployed
// admin) — no per-user choice, no localStorage, no overrides.
// t(key, fallback) reads the reactive dict, so any reactive body using it re-renders
// the moment the bundle lands or the company's language changes (Company Details save).
import { signal } from './t4.js';
import { api } from './api.js';

export const translations = signal({});   // the active bundle (exported for tests/debugging)
const dict = translations;
export const locale = signal('en');
let loadedFor = '';

export function t(key, fallback){
  const v = dict.value[key];
  return v !== undefined ? v : (fallback !== undefined ? fallback : key);
}

export async function initI18n(companyId){
  const tag = String(companyId);
  if(loadedFor === tag) return;
  loadedFor = tag;
  try {                                           // no ?lang → the COMPANY's language
    const res = await api.get(`/companies/${companyId}/settings/translations/bundle`);
    dict.value = res.translations || {};
    locale.value = res.lang || 'en';
  } catch { loadedFor = ''; }                     // retry on the next screen render
}

// After Company Details changes the company language, pull the bundle again so the
// running app flips immediately.
export function reloadI18n(companyId){
  loadedFor = '';
  return initI18n(companyId);
}
